import React, { useMemo, useRef } from "react";
import { useI18n } from "@/i18n/I18nProvider";
import { useScrolledPast, useActiveSection } from "@/components/coach/useScrollSpy";
import { StickyCourseBar, CourseAnchorMenu } from "@/components/coach/CourseNav";
import { CoachHero, FeaturedCourses, UpcomingCourses, CoachClosing } from "@/components/coach/CoachSections";

const toList = (v) => (Array.isArray(v) ? v : v ? [v] : []);

export default function CoachEducation() {
  const { t } = useI18n();
  const ce = t.coachEducation;
  const featured = useMemo(() => toList(ce.featured), [ce.featured]);
  const anchorMenuRef = useRef(null);
  const showSticky = useScrolledPast(anchorMenuRef);
  const activeIdx = useActiveSection(featured.length);
  const hasMenu = featured.length > 1;

  return (
    <>
      {hasMenu && <StickyCourseBar ce={ce} featured={featured} visible={showSticky} activeIdx={activeIdx} />}
      <CoachHero ce={ce} />
      {hasMenu && <CourseAnchorMenu ref={anchorMenuRef} ce={ce} featured={featured} />}
      {featured.length > 0 && <FeaturedCourses ce={ce} featured={featured} />}
      <UpcomingCourses ce={ce} />
      <CoachClosing ce={ce} />
    </>
  );
}
